import { FC } from 'react'
import { useT } from '../../../../../_metronic/i18n/Metronici18n'
import { Button } from '../../../../components/Button/Button'
import { CriarRascunhoParams, useCriarRascunho } from './useCriarRascunho'

export type { EscopoRascunho } from './useCriarRascunho'

/**
 * - `compacta` (padrão): secundário pequeno, para ações dentro de um bloco de leitura.
 * - `principal`: botão primário, quando criar rascunho é a ação principal da tela/bloco.
 * - `secundaria`: contorno neutro, ao lado de uma ação principal (ex.: "Publicar").
 */
export type AparenciaCriarRascunho = 'compacta' | 'principal' | 'secundaria'

type Props = CriarRascunhoParams & {
  podeCriarRascunho?: boolean
  rotulo?: string
  className?: string
  aparencia?: AparenciaCriarRascunho
}

/**
 * "Criar rascunho a partir desta" (T7a AC4). A confirmação e a criação ficam em
 * `useCriarRascunho`, compartilhado com o menu de ações da listagem.
 */
export const CriarRascunhoButton: FC<Props> = ({
  podeCriarRascunho,
  rotulo,
  className,
  aparencia = 'compacta',
  ...params
}) => {
  const { t } = useT()
  const { confirmarECriar, enviando, erro } = useCriarRascunho(params)

  if (!podeCriarRascunho) {
    return null
  }

  return (
    <span className={className}>
      <Button
        variant={aparencia === 'secundaria' ? 'secondary-outline' : undefined}
        className={
          aparencia === 'principal'
            ? 'btn-primary d-inline-flex'
            : aparencia === 'compacta'
            ? 'btn-secondary d-inline-flex'
            : 'd-inline-flex'
        }
        size={aparencia === 'compacta' ? 'btn-sm' : undefined}
        onClick={confirmarECriar}
        disabled={enviando}
      >
        {enviando
          ? 'Criando...'
          : rotulo ??
            t('protocolos_triagem.criar_rascunho', undefined, 'Criar rascunho a partir desta')}
      </Button>

      {erro && (
        <div className='alert alert-danger mt-3' role='alert'>
          {erro}
        </div>
      )}
    </span>
  )
}
